import {
  FETCH_LEGACY_ORDERS,
  FETCH_LEGACY_ORDERS_SUCCESS,
  FETCH_LEGACY_ORDERS_ERROR,
} from './legacyOrderActionConstants';

// fetch legacy Orders
export const fetchLegacyOrders = (payload) => ({
  type: FETCH_LEGACY_ORDERS,
  payload,
});

export const fetchLegacyOrdersSuccess = (payload) => ({
  type: FETCH_LEGACY_ORDERS_SUCCESS,
  payload,
});

export const fetchLegacyOrdersError = (payload) => ({
  type: FETCH_LEGACY_ORDERS_ERROR,
  payload,
});
